import Title from "components/koohrokhi/Title";
import ChoosenItem from "components/koohrokhi/ChoosenItem";
import NewTabs from "components/koohrokhi/NewTabs";
import SliderKooh from "components/koohrokhi/SliderKooh";
import PlayerModal from "components/koohrokhi/PlayerModal";
import AddEditTrack from "components/koohrokhi/modal/AddEditTrack";
import BannerManagement from "components/koohrokhi/modal/BannerManagement";
import AboutTrack from "components/koohrokhi/AboutTrack";

import about from "../assets/images/New folder/bargozide ha/about mohandes.png";
import karbala from "../assets/images/New folder/bargozide ha/Rajebe Karbala pic.png";
import madar from "../assets/images/New folder/bargozide ha/hazrat madar.png";
import asir from "../assets/images/New folder/bargozide ha/asire entezar pic.png";
import chador from "../assets/images/New folder/bargozide ha/nakhe chador pic.png";

import "../components/koohrokhi/koohrokhi.scss";

import AudioPlayer from "react-modern-audio-player";

import { useEffect, useState, useContext } from "react";
import { AiOutlineCloseCircle, AiOutlineFullscreen } from "react-icons/ai";

import { GiMusicalScore } from "react-icons/gi";
import sendRequest from "hooks/useAxios";
import TrackContext from "context/TracksContext";
import { tokenGenerator } from "utils/helperFunctions";
import AuthenticationContext from "../Authentication/AuthenticationContext.ts";
import LoaderCustom from "utils/LoaderCustom";

export default function Koohrokhi() {
  const {
    typeModalTrack,
    setTypeModalTrack,
    setvalueEditModal,
    updateList,
    showAudioPlayer,
    setShowAudioPlayer,
    changePlayList,
    selectedTrackSearch,
  } = useContext(TrackContext);
  const [isLoader, setIsLoader] = useState(false);
  const [showPlayerModal, setShowPlayerModal] = useState(false);
  const [selectedAlbum, setSelectedAlbum] = useState([]);
  const [addTrackModal, setAddTrackModal] = useState(false);
  const [aboutTrackModal, setAboutTrackModal] = useState(false);
  const [selectedTrack, setSelectedTrack] = useState("");
  const [banners, setBanners] = useState([]);
  const [selectedPlaylist, setSelectedPlaylist] = useState("");
  const [tags, setTags] = useState();
  const [trackTabs, setTrackTabs] = useState([]);

  const [trackLists, setTrackLists] = useState([]);
  const [playList, setPlayList] = useState();
  const auth = useContext(AuthenticationContext);

  const changePlayListFunc = (value) => {
    console.log({ value });
    console.log({ selectedTrack });
    let temp = [],
      playlist = [];
    if (value.length !== 0 && selectedTrack !== "") {
      temp = [...value];
      const clickedTrackIndex = temp.findIndex(
        (track) => track.id === selectedTrack.id
      );
      const clickedTrack = temp.splice(clickedTrackIndex, 1)[0];
      const reorderedPlaylist = [
        ...temp.slice(clickedTrackIndex),
        ...temp.slice(0, clickedTrackIndex),
      ];
      temp = [clickedTrack, ...reorderedPlaylist];
      temp.map((val, i) => {
        playlist.push({
          id: parseInt(i + 1),
          name: val.title,
          writer: val.title,
          description: val.description,
          img: `http://ava.tatdemo.ir/${val.file ? val.file.path : ""}`,
          src: `http://ava.tatdemo.ir/${
            val.audio_file ? val.audio_file.path : ""
          }`,
        });
      });
      setPlayList(playlist);
    }
  };
  console.log({ playList });
  // console.log({ trackLists });
  useEffect(() => {
    if (selectedTrack !== "") {
      setShowAudioPlayer(false);
      changePlayListFunc(selectedPlaylist);
    }
    setShowAudioPlayer(false);
    // selectedPlayList(trackLists)
  }, [selectedTrack]);

  useEffect(() => {
    setIsLoader(true);
    async function loadPage() {
      await sendRequest("audio/Find_tags").then((res) => {
        setTags(res.data);
        setTrackTabs(
          res.data.filter(
            (v) =>
              v.id != 1 &&
              v.title != "" &&
              v.title != "undefined" &&
              v.title != undefined
          )
        );
      });
      await sendRequest("audio/search", {
        tags: "1",
      }).then((res) => {
        setTrackLists(res.data.resTitle);
        // setTagList(res.data.resTitle);
      });
      await sendRequest("audio/banner_list").then((res) =>
        setBanners(res.data.result)
      );
    }

    loadPage();
    setIsLoader(false);
  }, [updateList]);

  // useEffect(() => {
  //   if (trackLists.length !== 0 || banners.length !== 0) {
  //     setIsLoader(false);
  //     // selectedPlayList(trackLists);
  //   }
  // }, [trackLists, banners]);

  useEffect(() => {
    setShowAudioPlayer(false);
    if (selectedTrackSearch !== "") {
      if (
        typeof selectedTrackSearch === "object" &&
        selectedTrackSearch !== null &&
        !Array.isArray(selectedTrackSearch)
      ) {
        let temp;
        if (!selectedTrackSearch.sources) {
          temp = [
            {
              id: 1,
              name: selectedTrackSearch.title,
              writer: selectedTrackSearch.title,
              description: selectedTrackSearch.description,
              img: `http://ava.tatdemo.ir/${
                selectedTrackSearch.file ? selectedTrackSearch.file.path : ""
              }`,
              src: `http://ava.tatdemo.ir/${
                selectedTrackSearch.audio_file
                  ? selectedTrackSearch.audio_file.path
                  : ""
              }`,
            },
          ];
          setPlayList(temp);
        } else {
          temp = [
            {
              id: parseInt(1),
              name: selectedTrackSearch.title,
              writer: selectedTrackSearch.title,
              description: selectedTrackSearch.description,
              img: `http://ava.tatdemo.ir/${selectedTrackSearch.fileId}`,
              src: `http://ava.tatdemo.ir/${
                selectedTrackSearch.sources.length !== 0
                  ? selectedTrackSearch.sources[0].fileId
                  : ""
              }`,
            },
          ];
          setPlayList(temp);
        }
      } else {
        let temp = selectedTrackSearch[0].files.map((val, i) => ({
          id: parseInt(i + 1),
          name: val.cover.length !== 0 ? val.cover[0].title : "",
          writer: val.cover.length !== 0 ? val.cover[0].title : "",
          description: val.description,
          img: `http://ava.tatdemo.ir/${
            val.cover.length !== 0 ? val.cover[0].path : ""
          }`,
          src: `http://ava.tatdemo.ir/${val.path ? val.path : ""}`,
        }));
        setPlayList(temp);
      }
    }
  }, [changePlayList]);

  useEffect(() => {
    if (selectedTrackSearch !== "" || selectedTrack !== "") {
      setTimeout(() => {
        setShowAudioPlayer(true);
      }, 50);
    }
  }, [playList]);

  return (
    <>
      {isLoader ? (
        <LoaderCustom></LoaderCustom>
      ) : (
        <div className="mx-3 koohrokhi ">
          {auth.isLogged && (
            <div
              className="position-fixed p-1 d-flex cursor-pointer"
              style={{
                backgroundColor: "lightgray",
                right: 0,
                zIndex: 4,
                top: 110,
                borderTopLeftRadius: 5,
                borderBottomLeftRadius: 5,
                width: 40,
                height: 40,
              }}
              onClick={() => {
                setAddTrackModal(true);
                setTypeModalTrack("add");
                setvalueEditModal("");
              }}
            >
              <GiMusicalScore
                color="#fe0000"
                className="m-auto"
                style={{ width: 27, height: 27 }}
              />
            </div>
          )}
          <div className="d-flex ">
            <BannerManagement tags={tags} banners={banners} />
          </div>
          <SliderKooh banners={banners} />

          <div className="pt-3 pb-4">
            <Title txt={"برگزیده‌ها"} color={"#fe0000"} txtColor={"white"} />
            <div className="d-flex flex-wrap">
              {trackLists.length !== 0
                ? trackLists.map((value) => {
                    return (
                      <div className="col-xl-3 col-lg-4 col-sm-6 col-12">
                        <ChoosenItem
                          value={value}
                          setShowAudioPlayer={setShowAudioPlayer}
                          setShowPlayerModal={setShowPlayerModal}
                          setAddTrackModal={setAddTrackModal}
                          setAboutTrackModal={setAboutTrackModal}
                          src={value?.audio_file?.path}
                          setSelectedAlbum={setSelectedAlbum}
                          trackLists={trackLists}
                          selectedPlayList={setSelectedPlaylist}
                          setSelectedTrack={setSelectedTrack}
                        />
                      </div>
                    );
                  })
                : ""}
            </div>
          </div>
          <div className="mt-4 ">
            <Title
              txt="مهندس‌محمد‌کوهرخی"
              color={"#fe0000"}
              txtColor={"white"}
            />
            <div className="mt-4 d-flex about">
              <img
                src={about}
                style={{ width: 200, height: 200, objectFit: "contain" }}
              />
              <div
                className="mx-4 d-flex align-items-center"
                style={{ color: "white", textAlign: "justify" }}
              >
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد
                نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.
                کتابهای زیادی در شصت و سه درصد گذشته حال و آینده شناخت فراوان
                جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را
                برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در
                زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و
                دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد
                وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات
                پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.
              </div>
            </div>
          </div>
          <div className="mt-5 new-tab-ids" style={{ paddingBottom: 60 }}>
            <NewTabs
              tabTitle={trackTabs}
              setShowAudioPlayer={setShowAudioPlayer}
              setShowPlayerModal={setShowPlayerModal}
              setAddTrackModal={setAddTrackModal}
              setAboutTrackModal={setAboutTrackModal}
              setSelectedAlbum={setSelectedAlbum}
              trackLists={trackLists}
              selectedPlayList={setSelectedPlaylist}
              setSelectedTrack={setSelectedTrack}
            />
          </div>
          {showAudioPlayer && (
            <div
              className="position-sticky bg-light audio-player"
              style={{ bottom: 0, zIndex: 4 }}
            >
              <div className="d-flex" style={{ backgroundColor: "#1e1e1e" }}>
                <div
                  onClick={() => {
                    setShowAudioPlayer(false);
                    setSelectedTrack("");
                  }}
                >
                  <AiOutlineCloseCircle
                    color="red"
                    className="ms-2 cursor-pointer"
                    style={{ width: 20, height: 20 }}
                  />
                </div>
                <div
                  onClick={() => {
                    setShowAudioPlayer(false);
                    setShowPlayerModal(true);
                  }}
                >
                  <AiOutlineFullscreen
                    color="red"
                    className="ms-2 cursor-pointer"
                    style={{ width: 20, height: 20 }}
                  />
                </div>
              </div>
              <div className="text-center">
                <AudioPlayer
                  playList={playList}
                  audioInitialState={{
                    isPlaying: true,
                  }}
                  activeUI={{
                    all: true,
                  }}
                  placement={{
                    interface: {
                      templateArea: {
                        artwork: "row1-3",
                        playList: "row1-1",
                        trackInfo: "row1-2",
                        trackTimeCurrent: "row2-1",
                        progress: "row2-2",
                        trackTimeDuration: "row2-3",
                        playButton: "row4-2",
                        repeatType: "row4-1",
                        volume: "row4-3",
                      },
                    },
                  }}
                  volumeSliderPlacement="left"
                  progressType="bar"
                  rootContainerProps={{
                    colorScheme: "dark",
                  }}
                />
              </div>
            </div>
          )}
          <PlayerModal
            showPlayerModal={showPlayerModal}
            setShowPlayerModal={setShowPlayerModal}
            playList={playList}
            setShowAudioPlayer={setShowAudioPlayer}
          />
          <AddEditTrack
            show={addTrackModal}
            setShow={setAddTrackModal}
            type={typeModalTrack}
            tags={tags}
          />
          <AboutTrack
            show={aboutTrackModal}
            setShow={setAboutTrackModal}
            selectedAlbum={selectedAlbum}
          />
        </div>
      )}
    </>
  );
}
